import React, { useState, useEffect, useContext, useRef } from 'react';
import _, { debounce } from 'lodash';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';
import List from '@shared/component/List';
import TextInput from '@shared/component/TextInput';
import { AuthContext } from '@shared/context/AuthContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Multiselect from 'multiselect-react-dropdown';
import DropDown from '@shared/component/DropDown';
import CheckValidator from '@shared/checkValidator';
import MultiSelect from '@shared/component/MultiSelect';
import Lists from '@shared/component/Lists';
import { ActionValues, actionsPermissionValidator } from '@utils/static/commonUtils';
import Chip from '@shared/component/chip';

export function Notification() {
    const [errors, setError] = useState<any>({
        itemId: {
            required: true,
            error: true,
            message: 'Please select item',
        },
        categoryId: {
            required: true,
            error: true,
            message: 'Please select category',
        },
        appUserId: {
            required: true,
            error: true,
            message: 'Please select user',
        },
        message: {
            required: true,
            error: true,
            message: 'Please enter message',
        },
    });
    const listRef: any = useRef(null);
    const itemRef: any = useRef(null);
    const clearAppRef: any = useRef(null);
    const { setLoader } = useContext(AuthContext);
    const [categories, setCategories] = useState([]);
    const [disabledItem, setDisabledItem] = useState(false);
    const [items, setitems] = useState([]);
    const [id, setId] = useState(null);
    const [notification, setNotification] = useState([]);
    const [search, setSearch] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);
    const [recordCount, setRecordCount] = useState(0);
    const [formData, setFormData] = useState<any>({ itemId: null, categoryId: null, appUserId: [], message: '' });
    const [vendor, setVendor] = useState([]);
    const [viewData, setViewData] = useState<any>({
        message: '',
        itemData: null,
        categoryData: null,
        appUserName: [],
    });
    const [uservalue, setUserValue] = useState({});
    const [vendorFilter, setvendorFilter] = useState([]);
    const [appData, setAppData] = useState([]);
    const [showHideModel, setShowHideModel] = useState(false);
    const [edit, setEdit] = useState(false);

    const [columns, setColumns] = useState({
        id: 'ID',
        'category.name': 'Category',
        'item.name': 'Items',
        appUserName: 'Users',
        message: 'Message',
        // status: 'Status',
        actionSignUpReq: 'Action',
    });
    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
            setIsSubmit(false);
            setDisabledItem(false);

            errors['categoryId']['error'] = true;
            errors['itemId']['error'] = true;
            errors['appUserId']['error'] = true;
            errors['message']['error'] = true;
            setError(errors);
        } catch (error) {}
    };

    const getCategory = async () => {
        try {
            setLoader(true);
            const data = await APIService.getAll(`category/all/getall`, true, false);
            setCategories(data.data.data);
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };

    const searchItem = async (value: any, page: any) => {
        try {
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            const data = await APIService.getAll(
                `notify/search?page=${page}&order=desc&sort=createdAt&search=${value}`,
                true,
                false,
            );

            setNotification(data.data.data);
            setRecordCount(data?.data?.count || 0);
        } catch (err) {
            setLoader(false);
        }
    };

    const getNotification = async (page: any = 1) => {
        try {
            setLoader(true);
            const data = await APIService.getAll(`notify/get?page=${page}&sort=createdAt`, true, false);
            // setitems(data.data.data);
            setNotification(data.data.data);
            setRecordCount(data?.data?.count || 0);
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getNotification();
        getCategory();
        // getVendor();
    }, []);

    const createNotification = async () => {
        try {
            const isValid = await CheckValidator(errors, formData);
            setIsSubmit(!isValid);

            if (isValid) {
                if (!formData.message || formData.message == '') {
                    Notify('error', ' Message are required');
                    return;
                }
                const data: any = {
                    categoryId: formData.categoryId,
                    message: formData.message,

                    itemId: formData.itemId,
                };
                if (formData.appUserId.length >= 1) {
                    const userId = formData.appUserId.map(obj => obj.id);
                    const userNames = formData.appUserId.map(obj => obj.name);
                    data.appUserId = userId;
                    data.appUserName = userNames;
                }

                setLoader(true);
                const updateddata = await APIService.post('notify/send/notification', data, true, true);
                setLoader(false);
                if (updateddata.status === 200) {
                    Notify('success', ' Send notify successfully');
                    setFormData({});
                    setEdit(false);
                    handelModel(false);
                    getNotification();
                    listRef.current.clearSearchBox();
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const handleEdit = async (id: any) => {
        const findNotificationDetail = notification.find(data => data.id == id);

        setEdit(true);
        handelModel(true);

        setAppData(findNotificationDetail);
        setViewData({
            message: findNotificationDetail?.message,
            categoryData: {
                label: `${findNotificationDetail?.category?.name} ` || '',
                value: findNotificationDetail?.category?.id || 0,
            },
            itemData: {
                label: `${findNotificationDetail?.item?.name} ` || '',
                value: findNotificationDetail?.item?.id || 0,
            },
        });

        setDisabledItem(true);
    };

    const handlereset = () => {
        setEdit(false);
        setFormData({
            ['categoryId']: null,
            ['itemId']: null,
            ['appUserId']: null,
            ['message']: '',
        });
        itemRef.current.clearDropdown();
        clearAppRef.current.clearDropdown();
        setVendor([]);
        setitems([]);
        setDisabledItem(false);
        handelModel(false);
    };

    const getValue = (e: any) => {
        try {
            const data = { ...formData, ...e };
            setFormData(data);
        } catch (error) {}
    };

    const getMultiSelectValue = (e: any) => {
        try {
            getValue({ appUserId: e });
            errors['appUserId']['error'] = e?.length > 0 ? false : true;
            setError(errors);
        } catch (error) {}
    };

    return (
        <>
            <div className="container dash-container">
                <div className="dash_bread_box">
                    <ul>
                        <li>Notification</li>
                    </ul>
                </div>
                <div className="content_body_cover">
                    <Lists
                        ref={listRef}
                        headers={columns}
                        data={notification}
                        type={'add+delete'}
                        addUpdateText="Notification"
                        // updateStatus={updateStatus}
                        searchItem={searchItem}
                        getById={handleEdit}
                        // getDeleteIds={getDeleteIds}
                        handelModel={(e: boolean) => handelModel(e)}
                        recordCount={recordCount}
                        callPagination={getNotification}
                        showDeleteBtn={false}
                        hideCopy={true}
                    />
                </div>
                {showHideModel && (
                    <Modal
                        // scrollable={true}
                        show={true}
                        onHide={() => {
                            handelModel(false);
                            handlereset();
                        }}
                        backdrop="static"
                        size="lg"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title> {edit ? 'View' : 'Create Notification'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="material_form_cover">
                                <form
                                    onSubmit={e => {
                                        e.preventDefault();
                                    }}
                                >
                                    <div className="field_box field_no_margin">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="form-floating">
                                                    <MultiSelect
                                                        isDisabled={edit ? true : false}
                                                        isSingle={true}
                                                        options={categories}
                                                        placeholder={'Select Category*'}
                                                        getMultiSelectValue={(e: any) => {
                                                            // getValue(e);

                                                            if (e?.value) {
                                                                if (e.label == 'Transporter') {
                                                                    setVendor(categories[0]?.app_users);
                                                                    setDisabledItem(true);
                                                                    errors['itemId']['required'] = false;
                                                                } else {
                                                                    const check = categories.find(
                                                                        (category: any) => category.id === e.value,
                                                                    );
                                                                    setDisabledItem(false);

                                                                    setitems(check?.items || []);

                                                                    setVendor([]);
                                                                    getValue({
                                                                        appUserId: [],
                                                                    });
                                                                    errors['itemId']['required'] = true;
                                                                }

                                                                // getValue({ categoryId: e.value });
                                                                formData['categoryId'] = e.value;
                                                                setFormData(formData);
                                                                errors['categoryId']['error'] = false;
                                                                setError(errors);
                                                            } else {
                                                                getValue({
                                                                    categoryId: null,
                                                                    itemId: null,
                                                                    appUserId: [],
                                                                });
                                                                errors['categoryId']['error'] = true;
                                                                errors['appUserId']['error'] = true;
                                                                errors['itemId']['error'] = true;
                                                                errors['itemId']['required'] = true;
                                                                setDisabledItem(false);

                                                                setError(errors);
                                                                setitems([]);
                                                                setVendor([]);
                                                            }
                                                            itemRef.current.clearDropdown();
                                                            clearAppRef.current.clearDropdown();
                                                        }}
                                                        displayName="name"
                                                        displayValue="id"
                                                        isClearable={edit ? false : true}
                                                        setSelectedValues={
                                                            edit
                                                                ? viewData?.categoryData
                                                                : formData?.categoryData || null
                                                        }
                                                    />

                                                    {errors?.categoryId?.required &&
                                                        errors?.categoryId?.error &&
                                                        isSubmit && (
                                                            <div className="text-danger ft-12">
                                                                {' '}
                                                                {errors?.categoryId.message}
                                                            </div>
                                                        )}
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <MultiSelect
                                                    ref={itemRef}
                                                    isSingle={true}
                                                    isDisabled={disabledItem == true ? true : false}
                                                    options={items}
                                                    placeholder={`Select Items${errors?.itemId?.required ? '*' : ''}`}
                                                    getMultiSelectValue={(e: any) => {
                                                        if (e?.value) {
                                                            getValue({ itemId: e.value });
                                                            const check = items.find(
                                                                (items: any) => items.id === e.value,
                                                            );

                                                            setVendor(check?.app_users || []);

                                                            // formData['itemId'] = e.value;
                                                            // setFormData(formData);
                                                            errors['itemId']['error'] = false;
                                                            setError(errors);
                                                        } else {
                                                            getValue({ itemId: null, appUserId: [] });
                                                            setVendor([]);
                                                            // setitems([]);
                                                        }
                                                    }}
                                                    displayName="name"
                                                    displayValue="id"
                                                    isClearable={edit ? false : true}
                                                    setSelectedValues={
                                                        edit
                                                            ? viewData?.itemData.value == 0
                                                                ? null
                                                                : viewData?.itemData
                                                            : formData?.categoryData || null
                                                    }
                                                />

                                                {errors?.itemId?.required && errors?.itemId?.error && isSubmit && (
                                                    <div className="text-danger ft-12"> {errors?.itemId.message}</div>
                                                )}
                                            </div>
                                        </div>
                                        <br />
                                        <div className="row">
                                            <div className="col-sm-6">
                                                {edit ? (
                                                    <div className="form-floating chip_float_label_box">
                                                        <Chip label="Select user" item={appData?.appUserName} />
                                                    </div>
                                                ) : (
                                                    <>
                                                        <MultiSelect
                                                            ref={clearAppRef}
                                                            options={vendor}
                                                            placeholder={'Select User*'}
                                                            getMultiSelectValue={(e: any) => {
                                                                getMultiSelectValue(e);
                                                            }}
                                                            displayName="name"
                                                            displayValue="id"
                                                            notSelectDefault={true}
                                                            setSelectedValues={formData.appUserId || null}
                                                        />

                                                        {errors?.appUserId?.required &&
                                                            errors?.appUserId?.error &&
                                                            isSubmit && (
                                                                <div className="text-danger ft-12">
                                                                    {' '}
                                                                    {errors?.appUserId.message}
                                                                </div>
                                                            )}
                                                    </>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    {/* <Multiselect
                                                        options={vendor}
                                                        selectedValues={formData.userIds || []}
                                                        onSelect={handlevendor}
                                                        onRemove={handlevendor}
                                                        displayValue="name"
                                                        placeholder="Select User"
                                                    /> */}
                                                </div>
                                            </div>
                                        </div>
                                        <br></br>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="">
                                                    <div className="form-floating">
                                                        {' '}
                                                        <TextInput
                                                            data={{
                                                                type: 'textarea',
                                                                placeholder: 'Enter message here',
                                                                name: 'message',
                                                                id: 'floatingInput',
                                                            }}
                                                            controlName="message"
                                                            isSubmit={isSubmit}
                                                            setValue={(e: any) => {
                                                                getValue({ message: e?.message });
                                                            }}
                                                            className="form-control"
                                                            name="message"
                                                            placeholder="Leave a comment here"
                                                            id="floatingTextarea2"
                                                            value={edit ? viewData?.message : formData.message}
                                                            style={{ height: '100px' }}
                                                            disabled={edit ? true : false}
                                                            inputProps={errors}
                                                        ></TextInput>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {edit ? (
                                <></>
                            ) : (
                                <>
                                    <Button
                                        variant="secondary"
                                        className="btn dark_btn custom_btn"
                                        onClick={createNotification}
                                    >
                                        Send
                                    </Button>
                                    <Button
                                        variant="default"
                                        className="btn custom_btn border_btn with_icon"
                                        onClick={() => {
                                            handlereset();
                                            handelModel(false);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </>
                            )}
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        </>
    );
}
